import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { FC } from '../../Services'
import { AppLayout } from '../../Components/Common/AppLayout'
import { useAuth } from '../../Provider/AuthProvider'

function ProtectedRoute ({ roles }) {
  const location = useLocation()
  const { user } = useAuth()

  if (!FC.authenticated) {
    return <Navigate to='/login' replace state={{ from: location }} />
  }

  if (roles && !roles.includes(user?.user.role)) {
    return <Navigate to='/login' replace />
  }

  if (roles) return <Outlet />

  return <AppLayout />
}

export default ProtectedRoute
